import React from 'react';
import StepTemplateLogo from 'step_template_logo';
import showdown from 'showdown';
import xss from 'xss';

var markdownConverter = new showdown.Converter({
    simplifiedAutoLink: true,
    literalMidWordUnderscores:true
});

StepTemplate.propTypes = {
    template: React.PropTypes.object.isRequired,
    onAdditionRequested: React.PropTypes.func.isRequired,
    addButtonName: React.PropTypes.string,
    onInstallationRequested: React.PropTypes.func.isRequired,
    installButtonName: React.PropTypes.string,
    onUpdateRequested: React.PropTypes.func.isRequired,
    onDetailsRequested: React.PropTypes.func.isRequired,
    resolveLink: React.PropTypes.func.isRequired,
};

function StepTemplate(props){

    function getStatusText(template){
        if (template.IsBuiltIn) {
            return "by Octopus Deploy";
        }

        if (template.IsInstalled) {
            return "Installed";
        }

        return formatText(template.Author, 24);
    }

    function getStatusClass(template){
        if (template.IsBuiltIn) {
            return "template-status-built-in";
        }

        if (template.IsInstalled) {
            return "template-status-installed";
        }

        return "template-status-not-installed";
    }

    function getStatusLogo(template){
        if (template.IsBuiltIn) {
            return <i className="fontoctopus-octopus"></i>;
        }

        if (template.IsInstalled) {
            return <i className="fa fa-check-square-o" aria-hidden="true"></i>;
        }

        return <i className="fa fa-users" aria-hidden="true"></i>;
    }

    function getAddAction(template, onAdditionRequested, onInstallationRequested){
        if (template.IsInstalled) {
            return <button className="btn btn-success add" type="button" onClick={onAdditionRequested}>{props.addButtonName ? props.addButtonName : "Add step"}</button>;
        }
        return <button className="btn btn-success install" type="button" onClick={onInstallationRequested}>{props.installButtonName ? props.installButtonName : "Install and add step"}</button>;
    };

    function getAddActionDetailsClass(template){
        if (!template.IsInstalled) {
            return "add-action-details-not-installed";
        }

        if (template.HasUpdate) {
            return "add-action-details-update";
        }

        return "add-action-details-installed";
    };

    // Truncates text and optionally converts markdown to HTML and sanitizes for XSS
    function formatText(value, maxCharacters, convertMarkdown) {
        value = (value || '').trim().replace(/\r?\n|\r/g, " ");

        if (convertMarkdown) {
            value = xss(markdownConverter.makeHtml(value));
        }

        // Uses vendor/jquery-truncate-html, *not* the NPM package truncate.js
        return jQuery.truncate(value, {
            length: maxCharacters,
            words: true,
            noBreaks: true
        });
    }

    function getAddActionDetailsContent(template, onDetailsRequested, onUpdateRequested){
        if (!template.IsInstalled) {
            return <a onClick={onDetailsRequested}>View details</a>;
        }

        if (template.HasUpdate) {
            return <a onClick={onUpdateRequested}>Update available</a>;
        }

        return "";
    }

    var templateDescriptionHtml = {__html: formatText(props.template.Description, 76, true)};

    return <li className="step-template animated" onClick={props.template.IsInstalled ? props.onAdditionRequested : props.onInstallationRequested}>
        <StepTemplateLogo class="logo" size="medium" url={props.template.Links.Logo} resolveLink={props.resolveLink} enableCacheBreaker={false} />

        <div className="name">
            {formatText(props.template.Name, 36)}
        </div>
        <div className="description" dangerouslySetInnerHTML={templateDescriptionHtml}>
        </div>
        <div className={"template-status " + getStatusClass(props.template)}>
            <span>{getStatusText(props.template)}</span>
            {getStatusLogo(props.template)}
        </div>
        <div className="add-action">
            {getAddAction(props.template, props.onAdditionRequested, props.onInstallationRequested)}
            <div className={"add-action-details " + getAddActionDetailsClass(props.template)}>
                {getAddActionDetailsContent(props.template, props.onDetailsRequested, props.onUpdateRequested)}
            </div>
        </div>
    </li>;
};

export default StepTemplate;







// WEBPACK FOOTER //
// ./app/areas/projects/step-templates/step_template.jsx